// Web Push subscription manager for Ameenji CRM

const PUSH_SUB_KEY = "ameenji_push_subscribed";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function getPushPermission() {
  if (!isPushSupported()) return "unsupported";
  return Notification.permission;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const registration = await navigator.serviceWorker.register("/sw.js");
    return registration;
  } catch (err) {
    console.warn("SW registration failed:", err);
    return null;
  }
}

export async function subscribeToPush(api) {
  if (!isPushSupported()) return null;

  try {
    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    // Get VAPID public key from backend
    const keyRes = await api.get("/push/vapid-key");
    const vapidPublicKey = keyRes.data.public_key;
    if (!vapidPublicKey) return null;

    // Get service worker registration
    const registration = await navigator.serviceWorker.ready;

    // Check for existing subscription
    let subscription = await registration.pushManager.getSubscription();

    // If no subscription, create one
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
      });
    }

    // Send subscription to backend
    await api.post("/push/subscribe", {
      subscription: subscription.toJSON(),
      user_agent: navigator.userAgent,
    });

    localStorage.setItem(PUSH_SUB_KEY, "true");
    return subscription;
  } catch (err) {
    console.warn("Push subscription failed:", err);
    return null;
  }
}

export async function unsubscribeFromPush(api) {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await api.delete("/push/unsubscribe", {
        data: { endpoint: subscription.endpoint },
      });
      await subscription.unsubscribe();
    }
    localStorage.removeItem(PUSH_SUB_KEY);
  } catch (err) {
    console.warn("Push unsubscribe failed:", err);
  }
}

export function isSubscribed() {
  return localStorage.getItem(PUSH_SUB_KEY) === "true";
}
